import axiosMethods from "../mixins/axios";

export default {
  async getInfoByAddress(address) {
    return await axiosMethods.get(
      `https://nominatim.openstreetmap.org/search?q=${address}&addressdetails=1&accept-language=fi&limit=10&format=jsonv2`
    );
  },
};
